/* Source: /app/lib/python_thread.cl.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
class PythonThread {
  constructor(loadedCallback) {
    let sharedBuffer = Reflect.construct(SharedArrayBuffer, [(4 * 3)]);
    this.sharedInts = Reflect.construct(Int32Array, [sharedBuffer]);
    this.pythonThread = Reflect.construct(Worker, ["/static/assets/python.js"]);
    console.log("Python Worker initialized");
    this.callbackLoaded = loadedCallback;
    this.callbackStdout = null;
    this.callbackStderr = null;
    this.callbackConversionResult = null;
    this.callbackBreakHit = null;
    this.callbackExecEnd = null;
    this.callbackJacGraph = null;
    this.pythonThread.onmessage = this.messageHandler.bind(this);
    this.pythonThread.postMessage({"type": "initialize", "sharedBuffer": sharedBuffer});
  }
  async messageHandler(event) {
    let data = event.data;
    if ((data.type === "initialized")) {
      console.log("Python Thread initialized");
      if (data.success) {
        console.log("Python environment is ready");
      } else {
        console.error("Failed to initialize Python environment");
      }
      if ((this.callbackLoaded !== null)) {
        try {
          this.callbackLoaded(data.success);
        } catch (__jac_e) {
          if (true) {
            console.error("callbackLoaded threw:", err);
          } else {
            throw __jac_e;
          }
        }
      }
    } else if ((data.type === "stdout")) {
      if ((this.callbackStdout !== null)) {
        this.callbackStdout(data.output);
      }
    } else if ((data.type === "stderr")) {
      if ((this.callbackStderr !== null)) {
        this.callbackStderr(data.output);
      }
    } else if ((data.type === "conversionResult")) {
      if ((this.callbackConversionResult !== null)) {
        this.callbackConversionResult(data.result);
      }
    } else if ((data.type === "breakHit")) {
      if ((this.callbackBreakHit !== null)) {
        this.callbackBreakHit(data.line);
      }
    } else if ((data.type === "execEnd")) {
      if ((this.callbackExecEnd !== null)) {
        this.callbackExecEnd();
      }
    } else if ((data.type === "jacGraph")) {
      if ((this.callbackJacGraph !== null)) {
        this.callbackJacGraph(data.graph);
      }
    }
  }
  async startExecution(code) {
    this.pythonThread.postMessage({"type": "startExecution", "code": code});
  }
  async startConversion(conversionType, inputCode) {
    this.pythonThread.postMessage({"type": "convertCode", "conversionType": conversionType, "inputCode": inputCode});
  }
  async startPythonExecution(code) {
    this.pythonThread.postMessage({"type": "executePython", "code": code});
  }
  async setBreakpoints(breakpoints) {
    this.pythonThread.postMessage({"type": "setBreakpoints", "breakpoints": breakpoints});
  }
  async continueExecution() {
    this.sharedInts[0] = 1;
    this.sharedInts[1] = 3;
    Atomics.notify(this.sharedInts, 0, 1);
  }
  async stepOver() {
    this.sharedInts[0] = 1;
    this.sharedInts[1] = 4;
    Atomics.notify(this.sharedInts, 0, 1);
  }
  async stepInto() {
    this.sharedInts[0] = 1;
    this.sharedInts[1] = 5;
    Atomics.notify(this.sharedInts, 0, 1);
  }
  async stepOut() {
    this.sharedInts[0] = 1;
    this.sharedInts[1] = 6;
    Atomics.notify(this.sharedInts, 0, 1);
  }
  async terminate() {
    this.sharedInts[0] = 1;
    this.sharedInts[1] = 7;
    Atomics.notify(this.sharedInts, 0, 1);
  }
}
export {PythonThread};